"use strict";

exports.__esModule = true;
exports.TicketComments = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _core = require("@blueprintjs/core");
var _reactFinalForm = require("react-final-form");
var _FormGroupField = require("../../Form/FormGroupField");
var _DetailsComponent = require("../../Core/DetailsComponent");
var _DownloadCommentsSection = require("./DownloadCommentsSection");
var _LogbookItemDescription = require("../../Logbook/LogbookItems/LogbookItemDescription");
var _Auth = require("../../Auth");
var _User = require("../../User");
var _EditTicketComment = require("./EditTicketComment");
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var TicketComments = exports.TicketComments = function TicketComments(props) {
  var _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    comments = props.comments,
    onSubmit = props.onSubmit,
    isFullScreen = props.isFullScreen,
    ticketId = props.ticketId,
    onCommentEdit = props.onCommentEdit,
    onCommentDelete = props.onCommentDelete;
  var handleSubmit = function handleSubmit(values) {
    return onSubmit(values.comment);
  };

  // Edit Comment
  var _useState = (0, _react.useState)(""),
    editingCommentId = _useState[0],
    setEditingCommentId = _useState[1];
  var handleCommentEdit = function handleCommentEdit(commentId, comment) {
    return onCommentEdit(commentId, comment);
    // setEditingCommentId("");
  };
  var handleCancelCommentEdit = function handleCancelCommentEdit() {
    setEditingCommentId("");
  };
  var _handleCommentEditClick = function handleCommentEditClick(commentId) {
    setEditingCommentId(commentId);
  };
  var _React$useContext = _react["default"].useContext(_Auth.AuthContext),
    username = _React$useContext.username;
  var users = _react["default"].useContext(_User.UserListContext);
  var currentUser = users.getUserByName(username);
  var currentUserId = currentUser && currentUser.id;

  // Add Comments - Body
  var addCommentContent = function addCommentContent() {
    return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
      onSubmit: handleSubmit
    }, function (_ref) {
      var form = _ref.form,
        handleSubmit = _ref.handleSubmit,
        pristine = _ref.pristine,
        invalid = _ref.invalid,
        submitting = _ref.submitting;
      return /*#__PURE__*/_react["default"].createElement("form", {
        style: {
          width: "100%"
        },
        onSubmit: (/*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _context.n = 1;
                  return handleSubmit(event);
                case 1:
                  form.reset();
                  form.resetFieldState("comment");
                case 2:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }())
      }, /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
        name: "comment",
        validate: _EditTicketComment.validateComment
      }, function (_ref3) {
        var input = _ref3.input;
        return /*#__PURE__*/_react["default"].createElement(_core.TextArea, _extends({
          "data-testid": "TicketComments_CreateCommentTextArea",
          disabled: disabled,
          fill: true,
          style: {
            height: "60px"
          }
        }, input));
      }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        "data-testid": "TicketComments_CreateCommentSubmit",
        style: {
          marginBottom: "0.5rem"
        },
        type: "submit",
        intent: _core.Intent.PRIMARY,
        loading: submitting,
        text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "TicketDetailsPage.create.button.comment",
          defaultMessage: "Create Comment"
        }),
        disabled: pristine || invalid || disabled
      }));
    });
  };

  // Show Comments Block
  return /*#__PURE__*/_react["default"].createElement(_styles.TicketCommentsWrapper, {
    disabled: disabled
  }, editingCommentId === "" && /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
    heading: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "TicketDetailsPage.addComment",
      defaultMessage: "Add Comment"
    }),
    content: addCommentContent()
  }), /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
    disabled: disabled,
    heading: /*#__PURE__*/_react["default"].createElement(_styles.CommentHeadingWrapper, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        margin: "auto 0"
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "TicketDetailsPage.commentsLabel",
      defaultMessage: "Comments"
    })), /*#__PURE__*/_react["default"].createElement(_DownloadCommentsSection.DownloadCommentsSection, {
      comments: comments,
      ticketId: ticketId
    }))
  }), comments && /*#__PURE__*/_react["default"].createElement(_styles.CommentsRow, {
    isFullScreen: isFullScreen,
    isEditing: !!editingCommentId
  }, comments.map(function (comment) {
    var isEditing = comment.id === editingCommentId;
    var ticketComment = {
      comment: comment,
      handleCommentEdit: handleCommentEdit,
      handleCancelCommentEdit: handleCancelCommentEdit,
      handleCommentEditClick: function handleCommentEditClick() {
        return _handleCommentEditClick(comment.id);
      },
      handleCommentDeleteClick: function handleCommentDeleteClick() {
        return onCommentDelete(comment.id);
      },
      isAuthorized: currentUserId === comment.creatorId,
      isEditing: isEditing,
      disabled: disabled
    };
    return /*#__PURE__*/_react["default"].createElement(_styles.TicketComment, {
      key: comment.id
    }, /*#__PURE__*/_react["default"].createElement(_LogbookItemDescription.LogbookItemDescription, {
      title: comment.body,
      creator: comment.creator,
      created: comment.created,
      ticketComment: ticketComment
    }));
  })));
};